import React, { useState, useEffect } from "react";
import { Modal, Autocomplete, TextField } from "@mui/material";
import Swal from "sweetalert2";
import request from "../../../Helpers/API";
import PlantillaScreen from "../../helpers/PlantillaScreen";

export const CultivoModal = ({ open, onClose, folio, cultivo, idestado }) => {
    const [loader, setLoader] = useState({
        mostrar: false,
        alerta: false,
        error: false,
        mensaje: "",
    });

    //   console.log(cultivo, idestado)

    const [state, setState] = useState({
        cultivo: cultivo,
    });
    const [cultivos, setCultivos] = useState([])
    
    
    useEffect(() => {
        setLoader({ ...loader, mostrar: true });

        request
            .get(
                `CotizacionVentas/CultivosListado?adr=${idestado}`
            )
            .then((result) => {
                setLoader({ ...loader, mostrar: false });
                setCultivos(result)

                // Buscamos el objeto completo en el listado para mostrarlo en el Autocomplete
                if (cultivo.toLowerCase() !== "sin cultivo seleccionado") {

                    const cultivoSeleccionado = result.find(
                        (c) => c.descripcion === cultivo
                    );

                    if (cultivoSeleccionado) {
                        setState((prev) => ({
                            ...prev,
                            cultivo: cultivoSeleccionado,
                        }));
                    }
                }
            })
            .catch((error) => {
                setLoader({ ...loader, mostrar: false });
                Swal.fire("COTIZACIONES", JSON.stringify(error), "error");
            });
    }, [idestado]);

    const onCerrar = () => {
        setState({
            ...state,
            cultivo: ""
        })

        onClose()
    }

    const opcionesCultivo = cultivos;

    const onGuardar = () => {
        if (!state.cultivo) {
            Swal.fire(
                "COTIZACIONES",
                "Favor de seleccionar el cultivo para la cotización",
                "info"
            );
            return;
        }

        setLoader({ ...loader, mostrar: true });

        request
            .get(
                `CotizacionVentas/GuardarCultivo?folio=${folio}&cultivo=${state.cultivo.descripcion}`
            )
            .then((result) => {
                setLoader({ ...loader, mostrar: false });
                Swal.fire({
                    title: "COTIZACIONES",
                    text: "Cultivo registrado con éxito",
                    icon: "success",
                });
                setState({ cultivo: "" });
                onClose();
            })
            .catch((error) => {
                setLoader({ ...loader, mostrar: false });
                Swal.fire("COTIZACIONES", JSON.stringify(error), "error");
            });
    };

    return (
        <Modal open={open} onClose={onCerrar}>
            <div className="comentarios-cotizaciones-modal-formulario">
                <div className="comentarios-cotizaciones-modal-plantilla">
                    <div
                        className="plantilla-screen-filtro-container"
                        id="mdlFiltros-modal"
                    >
                        <PlantillaScreen
                            titulo={"CULTIVO COTIZACIÓN"}
                            className_main={1}
                            className={"plantilla-screen-filtro-container-modal"}
                        >
                            <div className="cerrar-modal-button" onClick={onCerrar}>
                                X
                            </div>

                            <div className="comentarios-cotizaciones-modal">
                                <div className="comentarios-cotizaciones-modal-container">
                                    <div className="listado-clientes-gestionar-header-control">
                                        <Autocomplete
                                            fullWidth
                                            options={opcionesCultivo}
                                            getOptionLabel={(option) => option.descripcion || ""}
                                            value={state.cultivo}
                                            onChange={(event, newValue) =>
                                                setState({ ...state, cultivo: newValue || "" })
                                            }
                                            renderInput={(params) => (
                                                <TextField
                                                    {...params}
                                                    label="Seleccionar Cultivo"
                                                    color="success"
                                                    placeholder="Selecciona un cultivo..."
                                                />
                                            )}
                                            sx={{ mt: 2 }}
                                        />

                                        <div
                                            className="btn-serviciomdlguardar"
                                            onClick={onGuardar}
                                        >
                                            Guardar
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </PlantillaScreen>
                    </div>
                </div>
            </div>
        </Modal>
    );
};
